import { render } from "./ThePortfolio.vue?vue&type=template&id=5f40a248&scoped=true"
import script from "./ThePortfolio.vue?vue&type=script&lang=js"
export * from "./ThePortfolio.vue?vue&type=script&lang=js"

import "./ThePortfolio.vue?vue&type=style&index=0&id=5f40a248&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f40a248"]])

export default __exports__